var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defineComponent as _defineComponent } from 'vue';
import { vShow as _vShow, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed, getCurrentInstance, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'EResizer',
    props: {
        width: { default: 0 },
        height: { default: 0 },
        doubleScale: { type: Boolean },
        disabledResize: { type: Boolean },
        resizeBy: { default: function () { return ['all']; } },
        minWidth: { default: 50 },
        minHeight: { default: 50 },
        dividerSize: { default: 'small' },
        isDividerFull: { type: Boolean },
        isDividerTransparent: { type: Boolean },
        isDividerExternal: { type: Boolean },
        ignoreParentSize: { type: Boolean }
    },
    emits: {
        changeWidth: function (_newWidth) { },
        changeHeight: function (_newHeight) { },
        changeComplete: function () { },
        changeProcess: function () { }
    },
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var instance = getCurrentInstance();
        var props = __props;
        var emits = __emit;
        var visibleDivider = function (side) {
            var _a, _b;
            if (props.disabledResize) {
                return false;
            }
            if ((_a = props.resizeBy) === null || _a === void 0 ? void 0 : _a.includes('all')) {
                return true;
            }
            return (_b = props.resizeBy) === null || _b === void 0 ? void 0 : _b.includes(side);
        };
        var startedX = ref(null);
        var startedY = ref(null);
        var startedWidth = ref(0);
        var startedHeight = ref(0);
        var sideMove = ref(null);
        var rootRef = ref();
        var dividerSize = computed(function () { return props.dividerSize; });
        var resizeBoxStyles = computed(function () { return ({
            width: props.width ? "".concat(props.width, "px") : '',
            height: props.height ? "".concat(props.height, "px") : '',
            minWidth: "".concat(props.minWidth, "px"),
            minHeight: "".concat(props.minHeight, "px"),
        }); });
        var onMouseDown = function (e, side) {
            emits('changeProcess');
            startedX.value = e.clientX;
            startedY.value = e.clientY;
            startedWidth.value = props.width;
            startedHeight.value = props.height;
            sideMove.value = side;
            document.addEventListener('mousemove', mouseMove);
            document.addEventListener('mouseup', mouseUp);
        };
        var mouseUp = function () {
            startedX.value = null;
            startedY.value = null;
            sideMove.value = null;
            startedWidth.value = 0;
            startedHeight.value = 0;
            document.removeEventListener('mousemove', mouseMove);
            document.removeEventListener('mouseup', mouseUp);
            // При изменении размеров может быть ситуация,когда у блока задана максимальная высота/ширина
            // из-за этого установленая ширина не будет соответствовать реальным размерам и будет баг
            // Чтобы этого избежать при завершении изменений сохраняем реальную ширину/высоту
            // Но если ignoreParentSize=true, то используем установленные размеры вместо реальных
            if (props.ignoreParentSize) {
                // Используем установленные размеры, не реальные
                if (props.width) {
                    emits('changeWidth', props.width);
                }
                if (props.height) {
                    emits('changeHeight', props.height);
                }
            }
            else {
                // Используем реальные размеры как раньше
                var _a = rootRef.value.getBoundingClientRect(), width = _a.width, height = _a.height;
                if (props.width) {
                    emits('changeWidth', width);
                }
                if (props.height) {
                    emits('changeHeight', height);
                }
            }
            emits('changeComplete');
        };
        var mouseMove = function (e) {
            if (!sideMove.value) {
                return;
            }
            if (startedX.value) {
                resizeWidth(e.clientX);
            }
            if (startedY.value) {
                resizeHeight(e.clientY);
            }
        };
        var resizeWidth = function (eventClientX) {
            if (!startedX.value || !sideMove.value || !['left', 'right'].includes(sideMove.value) || !props.width) {
                return;
            }
            var sideFactorX = sideMove.value === 'left' ? 1 : -1;
            var pxMoveX = (startedX.value - eventClientX) * sideFactorX * (props.doubleScale ? 2 : 1);
            var newWidth = startedWidth.value + pxMoveX;
            if (!canChangeWidth(newWidth)) {
                return;
            }
            emits('changeWidth', newWidth);
        };
        var resizeHeight = function (eventClientY) {
            if (!startedY.value || !sideMove.value || !['top', 'bottom'].includes(sideMove.value) || !props.height) {
                return;
            }
            var sideFactorY = sideMove.value === 'top' ? 1 : -1;
            var pxMoveY = (startedY.value - eventClientY) * sideFactorY * (props.doubleScale ? 2 : 1);
            var newHeight = startedHeight.value + pxMoveY;
            if (!canChangeHeight(newHeight)) {
                return;
            }
            emits('changeHeight', newHeight);
        };
        var canChangeWidth = function (newWidth) {
            var _a;
            var parentWidth = (_a = instance === null || instance === void 0 ? void 0 : instance.proxy.$el.parentElement) === null || _a === void 0 ? void 0 : _a.clientWidth;
            if (!props.ignoreParentSize && parentWidth && parentWidth < newWidth) {
                return false;
            }
            return newWidth >= props.minWidth;
        };
        var canChangeHeight = function (newHeight) {
            var _a;
            var parentHeight = (_a = instance === null || instance === void 0 ? void 0 : instance.proxy.$el.parentElement) === null || _a === void 0 ? void 0 : _a.clientHeight;
            if (!props.ignoreParentSize && parentHeight && parentHeight < newHeight) {
                return false;
            }
            return newHeight >= props.minHeight;
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "rootRef",
                ref: rootRef,
                style: _normalizeStyle(__assign({}, resizeBoxStyles.value)),
                class: "resize-box"
            }, [
                _withDirectives(_createElementVNode("div", {
                    class: _normalizeClass([[
                            _ctx.isDividerFull && 'resize-divider-y--full',
                            _ctx.isDividerTransparent && 'resize-divider--transparent',
                            _ctx.isDividerExternal ? 'top-0 -translate-y-1/2' : 'top-[4px]',
                            dividerSize.value ? 'resize-divider-y--' + dividerSize.value : ''
                        ], "resize-divider-y resize-divider"]),
                    onMousedown: _cache[0] || (_cache[0] = _withModifiers(function ($event) { return (onMouseDown($event, 'top')); }, ["prevent"]))
                }, null, 34), [
                    [_vShow, visibleDivider('top')]
                ]),
                _withDirectives(_createElementVNode("div", {
                    class: _normalizeClass([[
                            _ctx.isDividerFull && 'resize-divider-x--full',
                            _ctx.isDividerTransparent && 'resize-divider--transparent',
                            _ctx.isDividerExternal ? 'left-0 -translate-x-1/2' : 'left-[4px]',
                            dividerSize.value ? 'resize-divider-x--' + dividerSize.value : ''
                        ], "resize-divider-x resize-divider"]),
                    onMousedown: _cache[1] || (_cache[1] = _withModifiers(function ($event) { return (onMouseDown($event, 'left')); }, ["prevent"]))
                }, null, 34), [
                    [_vShow, visibleDivider('left')]
                ]),
                _renderSlot(_ctx.$slots, "default", {
                    isResizing: !!sideMove.value,
                    class: "resize-element"
                }),
                _withDirectives(_createElementVNode("div", {
                    class: _normalizeClass([[
                            _ctx.isDividerFull && 'resize-divider-x--full',
                            _ctx.isDividerTransparent && 'resize-divider--transparent',
                            _ctx.isDividerExternal ? 'right-0 translate-x-1/2' : 'right-[4px]',
                            dividerSize.value ? 'resize-divider-x--' + dividerSize.value : ''
                        ], "resize-divider-x resize-divider"]),
                    onMousedown: _cache[2] || (_cache[2] = _withModifiers(function ($event) { return (onMouseDown($event, 'right')); }, ["prevent"]))
                }, null, 34), [
                    [_vShow, visibleDivider('right')]
                ]),
                _withDirectives(_createElementVNode("div", {
                    class: _normalizeClass([[
                            _ctx.isDividerFull && 'resize-divider-y--full',
                            _ctx.isDividerTransparent && 'resize-divider--transparent',
                            _ctx.isDividerExternal ? 'bottom-0 translate-y-1/2' : 'bottom-[4px]',
                            dividerSize.value ? 'resize-divider-y--' + dividerSize.value : ''
                        ], "resize-divider-y resize-divider"]),
                    onMousedown: _cache[3] || (_cache[3] = _withModifiers(function ($event) { return (onMouseDown($event, 'bottom')); }, ["prevent"]))
                }, null, 34), [
                    [_vShow, visibleDivider('bottom')]
                ])
            ], 4));
        };
    }
});
